import config from '@_src/common/core/config';
import appAuditStatusMap from '@_src/common/core/config/app/audit-status';
import allAbilityList from '@_src/common/core/config/ability/all-ability-list';
import entry from '@_src/common/core/config/menu';

export default {
  // 页面
  initRender: false,
  notice: [],
  // needLogin: false,
  // needEntry: true,
  needRole: '',
  needLogin: false,
  user: {
    isLogin: false,
    roleId: '',
    devs_info: {},
    user_info: {},
  },
  login: {
    show: false,
  },
  entry,
  entryList: config.hostType === 'open' ? [
    'index',
    'doc',
    'ability',
    'optcenter',
  ] : [],
  entryListStatus: 0,
  currentEntry: 'index',
  manageAppPathName: '',
  manageSidebar: [],

  // 业务
  system: { // 全局 system
    current: {}, // 当前选中的项目
    list: [], // 项目列表
  },
  mp: {},
  app: {
    current: {},
    list: [{ 'app': { 'name': '全部', 'id': '0' } }],
  },
  appAuditStatusMap, // 应用审核状态列表
  appTypeList: [], // 全平台的全部应用，从接口拿
  appTypeListFromProject: [], // mp2返回的已关联到项目的应用

  // ability
  allAbilityList,
  appDeployEnvOptions: [
    {
      label: '政务外网',
      value: '0',
    },
    {
      label: '互联网区',
      value: '1',
    },
  ],
};
